module.exports = __webpack_public_path__ + "img/punga-main.c067c1e5.jpg";